import React from "react";

const DefaultLinkElement = props => <a {...props}>{props.children}</a>;
const LinkElementContext = React.createContext(DefaultLinkElement);

export default LinkElementContext;
